export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "map.worker.82e43a66650ce1e36d35.bundle.worker.js");
}
